import { HStack, Flex, Select, Text, Divider, Box } from '@chakra-ui/react'
import { useSelector } from 'model/hooks'
import { FC } from 'react'
import _ from 'lodash'
import Label from 'shared/components/Label'

type Props = {
  label: string
  value?: string
  onChange: (v?: string) => void
}

const CourseSelect: FC<Props> = ({ label, value, onChange }) => {
  const librarycCourses = useSelector((state) => state.library)
  const courses = useSelector((state) => state.courses)
  return (
    <HStack w='full' justify={'space-between'}>
      <Label>{label}</Label>
      <Flex>
        <Select
          key={value}
          size='sm'
          variant={'flushed'}
          value={value}
          placeholder='не выбран'
          onChange={(e) =>
            onChange(e.target.value === '' ? undefined : e.target.value)
          }
        >
          <optgroup label='Library'>
            {_.map(librarycCourses, (p) => (
              <option key={p.id} value={p.id}>
                {p.title}
              </option>
            ))}
          </optgroup>
          <optgroup label='Courses'>
            {_.map(courses, (p) => (
              <option key={p.id} value={p.id}>
                {p.title}
              </option>
            ))}
          </optgroup>
        </Select>
      </Flex>
    </HStack>
  )
}

export default CourseSelect
